import { createGlobalStyle, styled } from 'styled-components';

export const v2 = {
  bg: '#05090F',
  bgSoft: '#0A1220',
  bgElevated: '#0E1828',
  surface: 'rgba(255, 255, 255, 0.04)',
  surfaceHover: 'rgba(255, 255, 255, 0.07)',
  border: 'rgba(255, 255, 255, 0.09)',
  borderStrong: 'rgba(255, 255, 255, 0.16)',
  text: '#F2F7FC',
  textMuted: 'rgba(226, 238, 248, 0.62)',
  textFaint: 'rgba(226, 238, 248, 0.38)',
  blue: '#1E96FC',
  blueSoft: 'rgba(30, 150, 252, 0.14)',
  orange: '#FF9F4F',
  orangeSoft: 'rgba(255, 159, 79, 0.14)',
  green: '#34D399',
  gradient: 'linear-gradient(96deg, #1E96FC 0%, #5BB8FF 45%, #FF9F4F 100%)',
  gradientBtn: 'linear-gradient(96deg, #1E96FC 0%, #0073D4 100%)',
  fontDisplay: "'Hanken Grotesk', sans-serif",
  fontBody: "'Hanken Grotesk', sans-serif",
  container: '1200px',
  ease: [0.21, 0.47, 0.32, 0.98],
};

export const CALENDLY_URL = 'https://calendly.com/foxi-abrechnung/30min';

/* Page-level styles shared by every page that uses the v2 design
   (dark canvas, body font, selection and scrollbar colours). */
export const V2GlobalStyle = createGlobalStyle`
  html {
    background: ${v2.bg};
  }

  body {
    background: ${v2.bg};
    font-family: ${v2.fontBody};
  }

  ::selection {
    background: rgba(30, 150, 252, 0.35);
    color: #fff;
  }

  ::-webkit-scrollbar {
    width: 9px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(30, 150, 252, 0.55);
  }

  ::-webkit-scrollbar-track {
    background: ${v2.bg};
  }
`;

/* Fixed film-grain overlay that gives the dark canvas its texture. */
export const Grain = styled.div`
  position: fixed;
  inset: 0;
  z-index: 90;
  pointer-events: none;
  opacity: 0.5;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.035 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
`;

export const Container = styled.div`
  width: 100%;
  max-width: ${v2.container};
  margin: 0 auto;
  padding: 0 24px;

  @media (max-width: 480px) {
    padding: 0 18px;
  }
`;

export const Section = styled.section`
  position: relative;
  padding: clamp(80px, 10vw, 140px) 0;
`;

export const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  border-radius: 100px;
  border: 1px solid ${v2.border};
  background: ${v2.surface};
  backdrop-filter: blur(12px);
  color: ${v2.textMuted};
  font-family: ${v2.fontBody};
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.6px;
  text-transform: uppercase;

  &::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${({ $accent }) =>
      $accent === 'orange' ? v2.orange : v2.blue};
    box-shadow: 0 0 12px
      ${({ $accent }) => ($accent === 'orange' ? v2.orange : v2.blue)};
  }
`;

export const Title = styled.h2`
  font-family: ${v2.fontDisplay};
  font-size: clamp(2rem, 4.6vw, 3.5rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.08;
  color: ${v2.text};
  margin: 0;

  .grad {
    background: ${v2.gradient};
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }
`;

export const Lead = styled.p`
  font-family: ${v2.fontBody};
  font-size: clamp(1.05rem, 1.4vw, 1.2rem);
  font-weight: 400;
  line-height: 1.65;
  color: ${v2.textMuted};
  margin: 0;
  max-width: 620px;
`;

export const SectionHead = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $left }) => ($left ? 'flex-start' : 'center')};
  text-align: ${({ $left }) => ($left ? 'left' : 'center')};
  gap: 22px;
  margin-bottom: clamp(48px, 6vw, 80px);
`;
